import { useMutation } from '@apollo/client';
import React, { FormEvent, useState } from 'react'
import { SUBMIT_RESET_PASSWORD } from '../../graphql/queries';
import { Modal, Button } from '@mantine/core';
import FormWrapper from '../../components/forms/FormWrapper';

export default function ForgotPasswordForm({ done }: { done: Function }) {
   const [formData, setFormData] = useState<Map<string, any>>(new Map())
   const [submitResetPassword, { loading }] = useMutation(SUBMIT_RESET_PASSWORD);

   const handleChange = ({ name, value }: any) => {
      setFormData((prev) => {
         return new Map([...prev, [name, value]])
      })
   }
   const handleSubmit = (ev: FormEvent) => {
      ev.preventDefault()
      console.log({ formData })
      submitResetPassword({
         variables: {
            data: Object.fromEntries(formData)
         }
      }).then((res) => {
         done()
      })
   }
   return (
      <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
         <FormWrapper fields={[
            { name: "email", label: "My email address", options: { required: true }, type: "email" }
         ]} formData={formData} updateFormData={handleChange} />
         <div className='flex justify-end items-center'>
            <Button type='submit'>{loading ? "Submiting, please wait ..." : "Submit"}</Button>
         </div>
      </form>
   )
}
